<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">{{ $t('menu.billList') }}</span>
      </div>
    </div>

    <div class="table-body flex vertical" v-loading="loading">
      <air-table
          ref="airTable"
          class="table-v2"
          :show-checkbox="false"
          align="center"
          :columns="columns"
          :data="tableData"
          @change-filter="changeFilter"
          :operation-column-width="180"
      >
        <template #operation="{ row }">
          <div class="flex center mt4">
            <span class="text-button" @click="toDetail(row)">{{ $t('viewDetails') }}</span>
            <div class="divider ml10 mr10"></div>
            <span class="text-button" @click="handleDownload(row)">{{ $t('downloadBills') }}</span>
          </div>
        </template>
      </air-table>

      <vxe-pager
          class="pager-v2"
          background
          :current-page.sync="queryParams.page"
          :page-size.sync="queryParams.limit"
          :total="total"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
          @page-change="getData"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/v2/service-process/bill'
import * as apiOrder from '@/api/v2/service-process/order'

export default {
  name: 'ServiceProcessBillList',
  components: {
  },
  data() {
    return {
      loading: true,
      queryParams: {
        page: 1,
        limit: 20,
      },
      total: 0,
      dictMap: {},
      columns: [
        {title: '客户名', itemEnName: 'Customer Name', field: 'cusName', minWidth: 120, filterType: 'input'},
        {title: '账单编号', itemEnName: 'Bill number', field: 'billNo', minWidth: 120, filterType: 'input'},
        {title: '账单月份', itemEnName: 'Bill month', field: 'billMonth', minWidth: 100, filterType: 'month'},
        {title: '账单状态', itemEnName: 'Bill status', field: 'processStatusText', minWidth: 100, filterType: 'select', filterOptions: []},
        {title: '账单总额', itemEnName: 'Total bill amount', field: 'receivable', money: true, minWidth: 100},
        {title: '实发总额', itemEnName: 'Total paid amount', field: 'actTotal', money: true, minWidth: 100},
        {title: '税金总额', itemEnName: 'Total Tax', field: 'taxTotal', money: true, minWidth: 100},
        {title: '服务费总额', itemEnName: 'Total service fee', field: 'serviceFeeTotal', money: true, minWidth: 100},
        {title: '服务人数', itemEnName: 'Number of service personnel', field: 'payCnt', minWidth: 80},
      ],
      tableData: [],
    }
  },
  computed: {
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.queryParams.cusId = this.$userInfo.cusId
      this.getData()
    },
    getData() {
      this.loading = true
      api.queryBillListByPage(this.queryParams).then(res => {
        const data = res.data.data
        if (!this.dictMap.processStatus) {
          this.dictMap.processStatus = this.$arrayToObj(data.billCodeItems['5033'], 'codeItemId')
          this.columns[2].filterOptions = data.billCodeItems['5033']
        }
        this.tableData = this.$handleTableDict(data.billDetailList, this.dictMap)
        this.total = data.params.total
        this.loading = false
      })
    },
    changeFilter(e) {
      this.queryParams = {...this.queryParams, ...e.filterData}
      this.getData()
    },
    toDetail(row) {
      this.$go('/v2/service-process/bill/detail', {
        id: row.id,
        batchIds: row.batchIds,
        cusId: row.cusId
      })
    },
    handleDownload(row) {
      this.$msgInfo(`${ this.$t('startDownloading') }`)
      apiOrder.exportNoticeDetail({
        id: row.id,
        isOtherBiz: false,
        contractType: '',
        contractCode: '',
        cusId: row.cusId
      }).then(res=>{
        this.$downloadFile(res)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";
</style>
